import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp:(
    `
    <p class="text-center bold mb-3">1</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Mi estas malgranda homo el malgranda Eúropo. <br/>
        Mi loĝas en malgranda, tamen ja propra domo, <br/>
        Havas mi malgrandan salajron kaj familion grandan, <br/>
        Kaj pro tiuj kialoj mi bone scipovas kalkuli: <br/>
        Kiom kostas studado en la Universitato, <br/>
        Kiom kostas manĝado, kiom – privata lernejo, <br/>
        Kiom da mono restis sur mia konto en banko <br/>
        Post la aĉeto de nova, tre bezonata aúto; <br/>
        Mi ja ne povas veturi al oficejo mia <br/>
        Per tiu malnoviĝinta, de pasintjara modelo: <br/>
        Mi perdos mian prestiĝon, oni min ne konfidos <br/>
        Kaj ne plialtigos salajron, tiam el kio mi pagos <br/>
        Krediton pro nova modelo de luksa polvosuĉilo?
      </p>

      <p class="poem-block mb-3">
        Mi estas malgranda homo el malgranda Eúropo, <br/>
        Mi havas malgrandajn zorgojn en mia malgranda mondo. <br/>
        Sed kiam fremdaj misiloj al nia lim’ proksimiĝis, <br/>
        Fariĝis glacie malvarma mia komforta hejmo <br/>
        Kaj ne plu protektas muroj kontraú neútrona morto, <br/>
        Kaj miaj malgrandaj zorgoj fariĝis unu grandega, <br/>
        Unu grandega, komuna por ĉiuj loĝantoj de l’ Tero: <br/>
        Konservi nian planedon vivanta kaj verde-blua, <br/>
        Konvena por ĉies vivo, por ia ajn vivo sur Tero. <br/>
        Ne estos plu rusoj, francoj, nigruloj aŭ usonanoj – <br/>
        Restos nur unu homaro, racia gento sur Tero, <br/>
        Krono de la kreaĵo, ne ĝia pereiginto.
      </p>
    </div>

    
    <p class="text-center bold mt-3 mb-3">2</p>


    <div class="poem">
      <p class="poem-block mb-3">
        Nin informas gazetoj: <br/>
        Hodiaŭ pereis tiom da, <br/>
        Murditaj, pafitaj – tiom da, <br/>
        Pendumigitaj – tiom da! <br/>
        Kion ankoraŭ vi volas? <br/>
        Sufiĉe, haltu, jam bolas <br/>
        La Tero pro sang-inundo <br/>
        Kaj skuas sin ĝis profundo: <br/>
        Anstataŭ la lando – vundo <br/>
        Sur la vizaĝ’ de la Tero, <br/>
        Anstataŭ prospero – <br/>
        Mizero, <br/>
        Kaj glata ŝtata malvero; <br/>
        Jen gloras denove poetoj <br/>
        La heroaĵon militan <br/>
        Kun nobla celo faritan: <br/>
        Honestan kaj senprofitan <br/>
        Apogon al ŝtatoj etaj, <br/>
        Tamen eksplodi pretaj <br/>
        Kun tuta nia planedo, <br/>
        De l’ Homo freneza predo. <br/>
        Mi timas, mi krias pro timo, <br/>
        Ne volas mi esti viktimo; <br/>
        Sed malgraŭ preĝoj kaj petoj <br/>
        Plukreskas ruĝa makulo <br/>
        De la tutplaneda brulo, <br/>
        Ĝi estas jam en proksimo. <br/>
        Nin savos neniu saĝulo, <br/>
        Nin savos nur kontraŭstaro <br/>
        Persista al la registaro. <br/>
        Se strebas ĝi al milito, <br/>
        Se por ĝi milito – <br/>
        Profito, <br/>
        Do nia respondo – nur spito. <br/>
        Vivaj – ni volas vivi! <br/>
        Mortu – milita morto! <br/>
        Estu – hom-inda sorto!
      </p>
    </div>


    <p class="text-center bold mt-3 mb-3">3</p>


    <div class="poem">
      <p class="poem-block mb-3">
        Baldaŭ mi foriros el tiu kaĝ’, <br/>
        La ĉagren’ inundas en mia sin’. <br/>
        La mond’ ne havas almenaŭ guton da saĝ’; <br/>
        Mi ne ŝatas kaj ne agnoskas ĝin.
      </p>

      <p class="poem-block mb-3">
        La patrino rakontis pri blua land’, <br/>
        Kie sonas kantoj de birda ĥor’… <br/>
        Kiel reprezentant’ de l’ danĝera band’ <br/>
        Estos mi mortpafita post unu hor’.
      </p>

      <p class="poem-block mb-3">
        Vivi – estas sukcesi unua al gorĝ’ <br/>
        Enkroĉiĝi kaj poste sin savi per fuĝ’. <br/>
        Vivi estas mensogi. Perfidi. Forges’ <br/>
        Kaj obe’ al pli fortaj – jen estas la leĝ’.
      </p>

      <p class="poem-block mb-3">
        Vipas politikistoj per fajfa skurĝ’, <br/>
        Kontraŭ volo mi krias kun ĉies kri’. <br/>
        Stop! Mi plu ne obeos. Ektremu, burĝ’! <br/>
        Via rolo finiĝis en Histori’.
      </p>

      <p class="poem-block mb-3">
        Ni mortigis garantiulojn. En plena aviadil’ <br/>
        Ni eksplodis bombojn, venĝante al mond’ de sinistr’. <br/>
        Estis de ni forrabita la ĉefministr’ <br/>
        Kaj prezident’ pafita en propra aŭtomobil’.
      </p>

      <p class="poem-block mb-3">
        Ĝuis ni potencon super la pita ar’, <br/>
        Igis nin fortaj kaj bravaj ilia tim’. <br/>
        Kiam subite trafis nin policikomisar’, <br/>
        Por moment’ mi embarasiĝis – kaj restis la sola viktim’.
      </p>

      <p class="poem-block mb-3">
        Jes, mi estas malforta. L’ potencoj potencos plu. <br/>
        En maljusta mondo ankoraŭ unu maljust’. <br/>
        Jam neniam min malsekigos la pluv’, <br/>
        Eble nur sango el kelkaj truetoj en brust’.
      </p>

      <p class="poem-block mb-3">
        Mi malkredis la mondon. La mondo mensogis min; <br/>
        Entute – remio. Estus mi deknaŭjarul’ en juni’. <br/>
        Nur mi volas, ke al neniu plu la patrin’ <br/>
        Rakontu pri blua mondo, damnita, neebla por ni.
      </p>
    </div>
    `
  )
}


const itemName = {
  esp: 'Kantoj de malgranda homo el malgranda Eŭropo de XX jc'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;